var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 36,
    viewBox: "0 0 143 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1914 24.7694L59.6638 12.5898H64.1206L58.2465 21.0667L64.1206 29.5593H59.6953L56.026 24.2652L52.341 29.5593H47.2228V6.30298H51.1914V24.7694Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3105 6.30298H70.279V29.5593H66.3105V6.30298Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.263 25.951L97.3026 12.5897H93.0034L99.3026 29.5592H100.909L98.5625 35.8303H102.925L111.633 12.5897H107.255L102.263 25.951Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.153 8.61903H120.121V12.5896H124.121V16.3554H120.121V29.5592H116.153V16.3554H112.153L113.554 12.5896H116.153V8.61903Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.972 12.2746C132.814 12.2746 131.019 13.2358 130.043 14.8271V12.6213H126.074V29.5751H130.043V20.594C130.043 17.9154 131.35 15.7725 134.074 15.7725C137.287 15.7725 138.546 17.8208 138.546 20.8618V29.5593H142.609V20.8618C142.609 15.6622 139.712 12.2746 134.972 12.2746Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3963 14.7167V12.5896H91.3648V29.5434H87.3963V27.4478C85.7585 29.1653 83.727 29.8901 81.286 29.8901C78.8608 29.8901 76.8451 29.055 75.2387 27.3848C73.6167 25.6831 72.7978 23.5875 72.7978 21.0665C72.7978 18.5455 73.6167 16.4499 75.2387 14.7482C76.8608 13.0781 78.8451 12.243 81.286 12.243C83.727 12.243 85.7742 12.9993 87.3963 14.7167ZM76.8923 21.0823C76.8923 23.9499 79.223 26.2819 82.0892 26.2819C84.9553 26.2819 87.286 23.9499 87.286 21.0823C87.286 18.2146 84.9553 15.8827 82.0892 15.8827C79.223 15.8827 76.8923 18.2146 76.8923 21.0823Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0421 4.14391C27.0027 1.59139 23.176 0.126051 19.2074 0L10.0893 24.1072L30.0421 4.14391Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3257 6.42858L20.861 17.8992L32.3257 29.3698C37.8532 22.7206 37.8532 13.062 32.3257 6.42858Z",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7349 2.75736L0.719061 16.7647C0.435595 21.271 1.85292 25.7143 4.70333 29.2122L14.7349 2.75736Z",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5774 20.1681L7.11279 31.6387C13.7585 37.1692 23.3963 37.1692 30.042 31.6387L18.5774 20.1681Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerLogo3);
export default __webpack_public_path__ + "static/media/partner_logo_3.71f1a237abf2483a4068c9b5172c5835.svg";
export { ForwardRef as ReactComponent };